import { Gebruikers } from "../WebMethods";
import { showAlert } from "../UI";
import { i18n } from "../I18n";
import * as I18nKeysShared from "../Locales/shared-map.json";

export class WachtwoordViewModel {
    public oudWachtwoord: KnockoutObservable<string> = ko.observable('');
    public nieuwWachtwoord1: KnockoutObservable<string> = ko.observable('');
    public nieuwWachtwoord2: KnockoutObservable<string> = ko.observable('');
    public errorMessage: KnockoutObservable<string> = ko.observable('');

    public onSaveSuccess: () => void = $.noop;
    public onSaveError: () => void = $.noop; 

    public constructor() { }

    public save() {
        if (this.isInputValid()) {
            Gebruikers.EditWachtwoord(this.nieuwWachtwoord1(), this.oudWachtwoord())
                .done(this.onSaveSuccess)
                .fail(this.onSaveError);
        }
        else {
            showAlert(this.errorMessage());
        }
    }

    public clearFields() {
        this.oudWachtwoord('');
        this.nieuwWachtwoord1('');
        this.nieuwWachtwoord2('');
    }

    private isInputValid(): boolean {
        if (this.oudWachtwoord() === '')
            this.errorMessage(i18n.t(I18nKeysShared.wachtwoord.message.error.oudWachtwoordLeeg));
        else if (this.nieuwWachtwoord1() === '')
            this.errorMessage(i18n.t(I18nKeysShared.wachtwoord.message.error.nieuwWachtwoordLeeg));
        else if (this.nieuwWachtwoord1() !== this.nieuwWachtwoord2())
            this.errorMessage(i18n.t(I18nKeysShared.wachtwoord.message.error.nieuweWachtwoordOngelijk));
        else if (this.oudWachtwoord() === this.nieuwWachtwoord1())
            this.errorMessage(i18n.t(I18nKeysShared.wachtwoord.message.error.oudEnNieuwWachtwoordIdentiek));
        else
            this.errorMessage('');

        return this.errorMessage().length === 0;
    }
}
